export type EventHandlerListener<A> = (t: A) => ReturnType<(parameter: A) => void>;

export interface IEventHandler {
    on<T>(eventName: string, listener: EventHandlerListener<T>): EventHandlerListener<T>;
    removeListener<T>(eventName: string, listener: EventHandlerListener<T>): void;
    emit<T>(eventName: string, args?: T): void;
    once<T>(eventName: string, listener: Function): void;
}
